import React from 'react'
import moment from 'moment'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { push, goBack } from 'react-router-redux'
import './Trips.css'
import Card from '../core/Card'
import SideNav from '../layout/SideNav'
import { MapIcon, Icon, TripsIcon, PaperclipIcon, NoteIcon, BackIcon, BriefcaseIcon, VehicleIcon, DotIcon, ForwardIcon, MergeIcon } from '../core/icons'
import { Row, Col, Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown, InputNumber, Tabs, Input } from 'antd';
import { connect } from 'react-redux'
import { toggleTrip, loadMore, getTrips, updateRange, selectFilter, clearFilters, selectPlaceFilter, updateTrip, updateNote, nameThisPlace } from './actions'
import Summary from './Summary'
import { withPreviousDate, getPurposes } from './reducer'
import Line from '../core/Line'
import numeral from 'numeral';
import styled from 'styled-components'
import {Map} from './MapCard'
import { Location } from './Location'
import { VehiclePicker } from './VehiclePicker'
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const {TextArea} = Input;

const PurposeStyle = styled.div`
.ant-select-selection-selected-value {
  font-size: 22px!important;
  svg, img { display: none; }
}

`
const PurposeLabel = styled.div`

`

const iconType = (purpose, income_source) => {
  if (purpose == null) {
    return "Unclassified"
  }
  return income_source || purpose
}

const Hover = ({ onHover, children }) => (
    <div className="hover">
        <div className="hover__no-hover">{children}</div>
        <div className="hover__hover">{onHover}</div>
    </div>
)

export const Purpose = ({token_id, isChecked, checkboxesVisible, purpose, income_source, updateTrip, purposes, toggleTrip})=>
  <PurposeStyle>
  <Row type="flex" className={"purpose " + purpose}>
    <Hover onHover={
      <Checkbox className="checkbox-large" onChange={()=>toggleTrip(token_id)} checked={isChecked} />
    }>
    {
      (checkboxesVisible)
        ? <Checkbox className="checkbox-large" onChange={()=>toggleTrip(token_id)} checked={isChecked} />
        : <Icon type={iconType(purpose, income_source)}
          height="30" selected/>
    }
  </Hover>
    <PurposeLabel >
      <div className={"purpose-label " + (income_source || purpose || 'Unclassified')}>
      <Select
        dropdownClassName="PurposeDropdown"
        showSearch
        notFoundContent={
          <span>Not found...
            <br/>

            <Link to="/account/business-lines">
              <AIcon type="edit"/>
               Add / change business lines
            </Link>

        </span>
        }
        placeholder="Unclassifed"
        optionFilterProp="children"
        dropdownMatchSelectWidth={false}
        size="large"
        filterOption={(input, option) =>
          option.props.children.props.children[1].props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={(value)=>updateTrip({token_id, purpose: value})}
        value={income_source || purpose || 'Unclassified'}
        >
          {purposes.map((p,i)=>
            <Option key={i} value={p}
              title={"Select to re-classify this trip"}
            >
              <Row type="flex" className={p} justify="center" align="middle">
                <Col>
                  <Icon type={p} selected color='#1abc9c'/>

                </Col>
                <Col>
                  {p}

                </Col>
              </Row>
            </Option>
          )}
        </Select>
        </div>
      </PurposeLabel>
  </Row>
</PurposeStyle>



// WEBPACK FOOTER //
// ./src/trips/Purpose.jsx